import { render, staticRenderFns } from "./pkg34.vue?vue&type=template&id=c56b915a&"
import script from "./pkg34.vue?vue&type=script&lang=js&"
export * from "./pkg34.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports